import { Params } from "./params";

export class MethodSummary {

    private modifierType: string;       //what type does method return?
    private methodName: string;         //what is the name of the method?
    private methodDescription: string;  //what does the method do?
    private methodParams: Params;     //what parameter types does the method take?
    private methodReturns: string;      //why does this method return this?

    constructor(modifierType:string,
        methodName:string,
        methodDescription:string,
        methodParams:Params,
        methodReturns:string )
    {
        this.modifierType = modifierType;
        this.methodName = methodName;
        this.methodDescription = methodDescription;
        this.methodParams = methodParams;
        this.methodReturns = methodReturns;

    }

    public getModifierType(){
        return this.modifierType;
    }

    public getMethodName(){
        return this.methodName;
    }

    public getMethodDescription(){
        return this.methodDescription;
    }

    public getMethodParams(){
        return this.methodParams;
    }

    public getParamsName(){
        return this.methodParams.getParamsName();
    }

    public getParamsSize(){
        return this.methodParams.getParams().length;       //returns size of array
    }

    public getMethodReturns(){
        return this.methodReturns;
    }


}